<script setup>
import { storeToRefs } from 'pinia'
import SocialEmail from 'assets/icons/social-email.svg'
import { useMessageStore } from '~/stores/messages'

// Fetch messages
const messagesStore = useMessageStore()
const { messages: staticKeys } = storeToRefs(messagesStore)

const parkingContactConfig = computed(() => {
    return {
        contactCount: 1,
        items: [
            {
                render: {
                    label: staticKeys.value?.parkingfirstpage_customerservice_email_mailto,
                    link: `mailto: ${staticKeys.value?.parkingfirstpage_customerservice_email_mailto}`
                },
                icon: SocialEmail,
                label: staticKeys.value?.parkingfirstpage_customerservice_email_text
            }
        ]
    }
})

const parkingHeadlineConfig = computed(() => {
    return {
        title: staticKeys.value?.parkingfirstpage_customerservice_headline_web_markdown,
        renderSplit: true
    }
})

// Track user click
const trackParkingContact = () => {
    trackUserClick({
        eventName: TRACKING_CONSTANTS.CLICK_EVENTS.PARKING_HOME_CLICK,
        button: TRACKING_CONSTANTS.MISC.CUSTOMER_SERVICE
    })
}
</script>

<template>
    <ContentHeadline :content-headline-config="parkingHeadlineConfig" />
    <SocialContactBar :social-contact-bar-config="parkingContactConfig" @click="trackParkingContact" />
</template>
